import type { UserContextStatus } from "../../lib/types";

const onboardingStatuses = new Set<UserContextStatus>([
  "LOGGED_IN_USER_WITH_ORG_PENDING_APPROVAL",
  "LOGGED_IN_UNREGISTERED_USER",
  "LOGGED_IN_USER_WITH_ORGANIZATION_AFFILIATION_REQUIRED",
  "LOGGED_IN_USER_WITH_NO_ORG"
]);

export function requiresOnboarding(status: UserContextStatus) {
  return onboardingStatuses.has(status);
}

// Staff use the same workspace; each API still enforces roles and location coverage.
export function isInboxOnlyWebUser(_status: UserContextStatus | undefined) {
  return false;
}
